enum BankType {
  ASA = "ASA",
  PROCREDIT = "PROCREDIT",
}

const BANK_TYPE_OPTIONS: readonly BankType[] = Object.values(BankType).filter((v): v is BankType => typeof v === "string") as BankType[];

const DEFAULT_BANK_TYPE: BankType = BankType.ASA;

const DISPLAY_LABELS: Record<BankType, string> = {
  ASA: "ASA",
  PROCREDIT: "Procredit",
};

const getBankLabel = (type: BankType): string => DISPLAY_LABELS[type];

const BANK_TYPES = BankType;

interface BankProviderEntry {
  id: number;
  name: string;
  type: BankType;
  username: string | null;
  password: string | null;
  isDefault: boolean;
}

interface CreateBankRequest {
  name: string;
  type?: BankType;
  username?: string;
  password?: string;
}

interface UpdateBankRequest {
  name?: string;
  type?: BankType;
  username?: string;
  password?: string;
}

interface BankCredentialsResponse {
  bankUsernameSet: boolean;
}

enum FormMode {
  IDLE = "idle",
  ADD = "add",
  EDIT = "edit",
}

interface AddFormState {
  name: string;
  type: BankType;
  username: string;
  password: string;
}

interface EditFormState {
  name: string;
  username: string;
  password: string;
}

interface BankSettingsValue {
  banks: BankProviderEntry[];
  loading: boolean;
  error: string;
  formMode: FormMode;
  editingId: number | null;
  addForm: AddFormState;
  patchAddForm: (partial: Partial<AddFormState>) => void;
  editForm: EditFormState;
  patchEditForm: (partial: Partial<EditFormState>) => void;
  loadBanks: () => Promise<void>;
  handleAddBank: () => Promise<void>;
  handleUpdateBank: (id: number, name?: string, username?: string | null, password?: string) => Promise<void>;
  handleSetDefault: (id: number) => Promise<void>;
  handleDelete: (id: number) => Promise<void>;
  startEdit: (bank: BankProviderEntry) => void;
  stopEditing: () => void;
  startAdding: () => void;
  cancelAdding: () => void;
}

export {
  type AddFormState,
  type BankCredentialsResponse,
  type BankProviderEntry,
  type BankSettingsValue,
  BankType,
  BANK_TYPES,
  BANK_TYPE_OPTIONS,
  type CreateBankRequest,
  DEFAULT_BANK_TYPE,
  type EditFormState,
  FormMode,
  type UpdateBankRequest,
  getBankLabel,
};
